import { ShippingAddresses } from './ShippingAddresses';

export const ShippingAddress = () => {
  return <ShippingAddresses />;
};
